import React from 'react';
import { FunctionField, Edit, SimpleForm, TextInput, AutocompleteInput } from 'react-admin';
import ImageInput from 'components/ImageInput';
import ReferenceInput from 'components/ReferenceInput';
import DateInput from 'components/DateInput';
import {
  ProfessionalQualificationAttribute,
  redirectOnUpsert,
} from 'resources/professional_qualification_attributes/utils';

const ProfessionalQualificationAttributeEdit = () => (
  <Edit mutationMode="pessimistic" redirect={redirectOnUpsert}>
    <SimpleForm>
      <ReferenceInput
        alwaysOn
        emptyText="All"
        source="professional_qualification.id"
        reference="ProfessionalQualification"
      >
        <AutocompleteInput optionText="id" />
      </ReferenceInput>
      <TextInput source="type" />
      <FunctionField
        label="Value"
        render={(record) => {
          const pqa = new ProfessionalQualificationAttribute(record);
          if (pqa.isImage || pqa.isPdf) {
            return <ImageInput record={record} source="value" extensionSource="extension" />;
          }
          if (pqa.isDate) {
            return <DateInput source="value" />;
          }
          return <TextInput source="value" />;
        }}
      />
    </SimpleForm>
  </Edit>
);

export default ProfessionalQualificationAttributeEdit;
